import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var myGroupBooking = [{
  path: "group-booking",
  name: "group-booking",
  component: function component() {
    return import("./group-booking.vue");
  }
}];